<h2 class="page-heading" data-testid="page-heading">
  {{ pageTitle | translate }}
</h2>
